import * as React from 'react'
import { closeBulkProjectTagModal } from '../../store/modals/actions'
import ModalHeader from './Parts/ModalHeader'
import TooltipError from '../Tooltips/ErrorTooltip'
import { ProjectsController } from '../../controllers'
import { AppState } from '../../store'
import { AnyAction, Dispatch } from 'redux'
import { connect } from 'react-redux'
import ModalWindow from './Parts/ModalWindow'
import ModalMiddle from './Parts/ModalMiddle'
import ModalLoader from './Parts/ModalLoader'
import ModalContent from './Parts/ModalContent'
import { withTranslation, WithTranslation } from 'react-i18next'
import { CurrentUser, ProjectTag } from '../../types'
import ResourceCreatablePowerSelect from '../Form/ResourceCreatablePowerSelect'
import Button from '../Button/Button'

interface IStateToProps {
  action: 'add' | 'remove'
  projectIds: string[]
  onSubmit?: (projectTags: ProjectTag[]) => void
  currentUser: CurrentUser
}

interface IDispatchToProps {
  close: typeof closeBulkProjectTagModal
}

type IProps = IDispatchToProps & IStateToProps & WithTranslation

export enum BulkProjectTagModalTab {
  DETAILS = 'details',
}

interface IState {
  didInitialLoad: boolean
  activeTab: BulkProjectTagModalTab
  selectedProjectTags: ProjectTag[]
  errors: any
}

class BulkProjectTagModal extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      didInitialLoad: false,
      activeTab: BulkProjectTagModalTab.DETAILS,
      selectedProjectTags: [],
      errors: {},
    }

    this.onProjectTagsChange = this.onProjectTagsChange.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onErrorsDismiss = this.onErrorsDismiss.bind(this)
  }

  componentDidMount(): void {
    setTimeout(() => {
      this.setState({ didInitialLoad: true })
    }, 250)
  }

  onProjectTagsChange(_tagIds, projectTags) {
    this.setState({
      selectedProjectTags: projectTags || []
    })
  }

  async onFormSubmit(e) {
    e.preventDefault()
    const { selectedProjectTags } = this.state
    const { close, onSubmit, t, action, projectIds } = this.props

    try {
      let success = false
      if (action === 'add') {
        const response = await ProjectsController.bulkAddTags(projectIds, selectedProjectTags.map(tag => tag.id))
        success = response.success
      } else if (action === 'remove') {
        const response = await ProjectsController.bulkRemoveTags(projectIds, selectedProjectTags.map(tag => tag.id))
        success = response.success
      }

      if (success) {
        if (onSubmit) onSubmit(selectedProjectTags)
        close()
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  onCloseClick() {
    this.props.close()
  }

  onErrorsDismiss() {
    this.setState({ errors: {} })
  }

  renderDetails() {
    const { t } = this.props
    const { activeTab, selectedProjectTags } = this.state

    if (activeTab !== BulkProjectTagModalTab.DETAILS) return null

    return (
      <div data-tab='details'>
        <div className='grid'>
          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>{t('ProjectModal::Tags')}</label>
              <ResourceCreatablePowerSelect
                type='project_tag'
                value={selectedProjectTags.map(tag => tag.id)}
                onChange={this.onProjectTagsChange}
                isClearable={true}
                placeholder={t('ProjectModal::Select project tags...')}
                isMulti
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { t, action } = this.props
    const { activeTab, didInitialLoad, errors } = this.state

    return (
      <ModalWindow>
        <ModalHeader
          title={action === 'add' ? t('BulkProjectTagModal::Assign tags') : t('BulkProjectTagModal::Remove tags')}
          onCloseClick={this.onCloseClick}
        />

        {!didInitialLoad && <ModalLoader />}
        {didInitialLoad && <ModalMiddle>
          <ModalContent>
            <form onSubmit={this.onFormSubmit}>
              {this.renderDetails()}
              <input type='submit' style={{ display: 'none' }} onClick={this.onFormSubmit} />
            </form>
          </ModalContent>

          <div className='modal-footer'>
            <div />
            <div className='modal-footer-actions'>
              <div key='main-action' className='popover-wrapper'>
                <TooltipError
                  errors={errors}
                  onDismiss={this.onErrorsDismiss}
                />
                <Button
                  type='success'
                  text={t('BulkProjectTagModal::Save')}
                  onClick={this.onFormSubmit}
                />
              </div>
            </div>
          </div>
        </ModalMiddle>}
      </ModalWindow>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    },
    modals: {
      bulkProjectTagModal: {
        action,
        projectIds,
        onSubmit
      }
    }
  } = state

  return {
    currentUser: currentUser,
    action: action,
    projectIds: projectIds,
    onSubmit: onSubmit,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    close: () => dispatch(closeBulkProjectTagModal()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BulkProjectTagModal))
